'use client';
import { useGridFilters } from '~features/gridFilters/hooks/useGridFilters';
import { useTranslations } from '~i18n/hooks';
import { ButtonGhost } from '~shared/ui/atoms/Buttons/ButtonGhost';

export const ClearFiltersPlaceholderButton = () => {
	const { clearFilters } = useGridFilters();
	const t = useTranslations('Grid');

	return (
		<ButtonGhost
			data-name="grid-placeholder-button"
			size="L"
			onClick={clearFilters}
		>
			{t('gridPlaceholderButton')}
		</ButtonGhost>
	);
};
